import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { InlineSpinner } from "components/Spinner";
import { API } from "aws-amplify";

/**
 * AdminReset
 */
const AdminReset = ({ onSubmit, align = "right" }) => {
  const [show, setShow] = useState(false);
  const [user, setUser] = useState("");
  const [tempPassword, setTempPassword] = useState("");
  const [showTempPassword, setShowTempPassword] = useState(false); // 👈 NEW
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null); // { status, message, email }
  
  const close = () => {
    setShow(false);
    // To clear on close, call resetAll() here.
  };
  const open = () => setShow(true);
  const resetAll = () => {
    setUser("");
    setTempPassword("");
    setShowTempPassword(false); // 👈 reset visibility
    setSubmitting(false);
    setResult(null);
  };
  
  const performRequest = async () => {
    if (typeof onSubmit === "function") {
      return await onSubmit({ user, tempPassword });
    }
    const data = await API.post("AccountGatewayApi", "/user/reset", {
      body: { username: user, val: tempPassword }
    });
    return {
      status: typeof data?.status === "number" ? data.status : 200,
      message: data?.message || "Password reset completed.",
      email: data?.email
    };
  };
  
  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      const resp = await performRequest();
      const status = typeof resp?.status === "number" ? resp.status : 200;
      const message = resp?.message || resp?.msg || resp?.detail || "Request complete.";
      const email = resp?.email || resp?.userEmail || resp?.to;
      setResult({ status, message, email });
    } catch (err) {
      const message = err?.response?.data?.message || err?.message || "Request failed.";
      setResult({ status: 500, message, email: undefined });
    } finally {
      setSubmitting(false);
    }
  };

  const success = result?.status === 200;

  const handleEmailUser = () => {
    const to = result?.email || user || "";
    const subject = "Perception Health Password Reset";
    const body = `Temporary Password: ${tempPassword}`;
    const mailto = `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailto;
  };

  return (
    <>
      <button
        className={align === "center" ? "btn btn-primary m-2 d-block mx-auto" : "btn btn-primary m-2 float-right"}
        onClick={() => { resetAll(); open(); }}
      >
        Reset User Password
      </button>

      <Modal size="lg" show={show} onHide={close}>
        <Modal.Header closeButton>
          <Modal.Title>Admin: Reset User Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            {result && (
              <div className={success ? "alert alert-success" : "alert alert-danger"} role="alert">
                {result.message}
              </div>
            )}

            <fieldset disabled={submitting || success}>
              <div className="form-group">
                <label htmlFor="admin-reset-user">User</label>
                <input
                  id="admin-reset-user"
                  type="text"
                  className="form-control"
                  value={user}
                  onChange={(e) => setUser(e.target.value)}
                  placeholder="Enter a user email or ID"
                />
              </div>

              <div className="form-group">
                <label htmlFor="admin-reset-temp">Temp Password</label>
                {/* 👇 Input group with Show/Hide toggle */}
                <div className="input-group">
                  <input
                    id="admin-reset-temp"
                    type={showTempPassword ? "text" : "password"}
                    className="form-control"
                    value={tempPassword}
                    onChange={(e) => setTempPassword(e.target.value)}
                    placeholder="Enter a temporary password"
                    autoComplete="new-password"
                  />
                  <div className="input-group-append">
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowTempPassword(v => !v)}
                      aria-label={showTempPassword ? "Hide password" : "Show password"}
                      aria-pressed={showTempPassword}
                    >
                      {showTempPassword ? "Hide" : "Show"}
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </Modal.Body>

        {!result || !success ? (
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-success m-2 float-right"
              style={{ backgroundColor: "#3c763d", borderColor: "#3c763d" }}
              onClick={handleSubmit}
              disabled={!user || !tempPassword || submitting}
              type="button"
            >
              {submitting && <InlineSpinner />} {submitting ? "Submitting..." : "Submit"}
            </button>
            <button
              className="btn btn-danger m-2 float-right"
              onClick={close}
              type="button"
              disabled={submitting}
            >
              Cancel
            </button>
          </div>
        ) : (
          <div className="d-flex flex-wrap justify-content-end">
            <button
              className="btn btn-success m-2"
              style={{ backgroundColor: "#3c763d", borderColor: "#3c763d" }}
              onClick={handleEmailUser}
              type="button"
            >
              Email User
            </button>
            <button
              className="btn btn-primary m-2"
              onClick={() => { resetAll(); }}
              type="button"
            >
              Submit Another Reset
            </button>
            <button
              className="btn btn-danger m-2"
              onClick={close}
              type="button"
            >
              Close
            </button>
          </div>
        )}
      </Modal>
    </>
  );
};

export default AdminReset;
